import Footer from "components/Footer";
import Header from "components/Header";
import useScroll from "hooks/useScroll";
// import React from "react";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";

const AppLayout = ({ children }) => {
  const { isLoading } = useAppSelector(getSettings);
  useScroll()

  if (isLoading) {
    return null;
  }

  return (
    <>
      <Header />
      <main className="">{children}</main>
      <Footer />
    </>
  );
};

export default AppLayout;
